import { TEmptyAsyncCallback } from "@/shared/types/functions"

enum ECoachNavigationStepperBulletOrder {
    Current = "current",
    NotCurrent = "notCurrent"
}

enum ECoachNavigationStepperBulletCompletion {
    Completed = "completed",
    NotCompleted = "notCompleted"
}

enum ECoachNavigationStepperBulletState {
    Normal = "normal",
    /**
     * @deprecated not used for now, will be added later
     */
    Error = "error"
}

enum ECoachNavigationStepperMode {
    Sessions = "sessions",
    Modules = "modules",
    Calendars = "calendars"
}

type TCoachNavigationStepperBullet = {
    isStub?: boolean // modules tab only!!
    onHover?: TEmptyAsyncCallback // modules tab only!!
    href: string | undefined
    pageId: number | undefined
    title: string | undefined
    subTitle: string | undefined
    order: ECoachNavigationStepperBulletOrder
    completion: ECoachNavigationStepperBulletCompletion
    state: ECoachNavigationStepperBulletState
}

export type { TCoachNavigationStepperBullet }
export {
    ECoachNavigationStepperBulletOrder,
    ECoachNavigationStepperBulletCompletion,
    ECoachNavigationStepperBulletState,
    ECoachNavigationStepperMode
}
